import { render } from "./VehiclesPage.vue?vue&type=template&id=40f8e30a&ts=true"
import script from "./VehiclesPage.ts?vue&type=script&lang=ts"
export * from "./VehiclesPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__